import React from 'react'

import { faEdit } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, IconButton, Link } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import PropTypes from 'prop-types'

import permissions from 'common/system-permissions'
import usePermissions from 'common/use-permissions'
import useUserScid from 'common/use-user-scid'

const RequestUpdateAction = ({ scid, isResponsive }) => {
  const userScid = useUserScid()
  const theme = useTheme()
  const displayButtonIcon = useMediaQuery(theme.breakpoints.down('xs')) && isResponsive
  const canCreateContent = usePermissions(permissions.MANAGE_COLLEGE_CONTENT)
  const canRequest = canCreateContent && userScid === scid

  return (
    <React.Fragment>
      {!canRequest ? null : (
        <Link
          href="https://www.scoir.com/college-data-update"
          target="_request-update"
        >
          {displayButtonIcon ? (
            <IconButton
              size="small"
              color="primary"
              variant="contained"
              aria-label="Request Update"
            >
              <FontAwesomeIcon
                size="sm"
                icon={faEdit}
              />
            </IconButton>
          ) : (
            <Button
              color="primary"
              variant="contained"
              aria-label="Request Update"
            >
              <FontAwesomeIcon icon={faEdit} />
              &nbsp;Request Update
            </Button>
          )}
        </Link>
      )}
    </React.Fragment>
  )
}

RequestUpdateAction.propTypes = {
  scid: PropTypes.number.isRequired,
  isResponsive: PropTypes.bool,
}

export default RequestUpdateAction
